import React, { useCallback, useEffect, useState } from 'react';
import CarouselItem from './CarouselItem';
import { SectionTitle } from '../../../Global/styles';
import {
	CarouselContainer,
	CarouselHeader,
	CarouselSwiper,
	CarouselSwiperSlide,
	ProgressBar,
	ProgressInner,
} from './carouselStyles';
import 'swiper/css';
import 'swiper/css/free-mode';
import FilterButton from '../FilterButton/FilterButton';
import { Trail } from '../../../../models/Trail';
import { IonSelectCustomEvent } from '@ionic/core';
import { SelectChangeEventDetail } from '@ionic/react';

type CarouselProps = {
	items: Trail[];
};

const FilteredCarousel: React.FC<CarouselProps> = ({ items }) => {
	const [swiper, setSwiper] = useState({ realIndex: 0 });
	const [progress, setProgress] = useState('');

	const handleSlideChange = () => {
		calculateTotalProgress();
		console.log();
	};

	const calculateTotalProgress = useCallback(() => {
		const total = items.length;
		const currentProgress = swiper.realIndex + 1;
		const currentPercentage = 100 / (total / currentProgress);
		setProgress(`${currentPercentage}%`);
	}, [items.length, swiper.realIndex]);

	const handleFilterChange = (
		e: IonSelectCustomEvent<SelectChangeEventDetail<any>>,
	) => {
		console.log(e);
		return {};
	};

	useEffect(() => {
		if (items.length === 0) return;
		calculateTotalProgress();
	}, [items, calculateTotalProgress]);

	return (
		<CarouselContainer>
			<CarouselHeader>
				<div>
					<SectionTitle>Trails</SectionTitle>
				</div>
				<div>
					<FilterButton onChangeHandler={handleFilterChange} />
				</div>
			</CarouselHeader>

			<CarouselSwiper
				slidesPerView={'auto'}
				spaceBetween={8}
				className="carousel-swiper"
				onSlideChange={() => handleSlideChange()}
				onSwiper={(swiper) => setSwiper(swiper)}>
				{items.map((item) => (
					<CarouselSwiperSlide key={item.id}>
						<CarouselItem item={item} />
					</CarouselSwiperSlide>
				))}
			</CarouselSwiper>

			<ProgressBar>
				<ProgressInner $progress={progress} />
			</ProgressBar>
		</CarouselContainer>
	);
};

export default FilteredCarousel;
